<template>
    <button class="db-table-action db-btn-outline sm default danger transparent">
        <i class="lab lab-line-trash"></i>
        <span class="db-tooltip">{{ $t('button.delete') }}</span>
    </button>
</template>

<script>
export default {
    name: "SmIconDeleteComponent",
}
</script>

<style scoped>

</style>
